import { defineStore } from "pinia";
import SessionStorageService from "@/services/SessionStorageService";
import { AuthenticationApi, ResponseError } from "@/apiGenerate/authentication";
import { authenticationApiConfig } from "@/config/authentication-api.config";
import router from "@/router";
import { Auth } from "@/models/auth.model";
import { Routes } from "@/models/layout.model";

const api = new AuthenticationApi(authenticationApiConfig);

export const authStore = defineStore("auth", {
    state: () => ({
        idToken: SessionStorageService.getItem(Auth.TOKEN),
        refreshToken: SessionStorageService.getItem(Auth.REFRESH_TOKEN),
        refreshInterval: null as ReturnType<typeof setInterval> | null,
        toasterMessage: "",
        toasterStyle: ""
    }),

    actions: {
        setTokens(idToken: string, refreshToken: string) {
            this.idToken = idToken;
            this.refreshToken = refreshToken;

            SessionStorageService.setItem(Auth.TOKEN, idToken);
            SessionStorageService.setItem(Auth.REFRESH_TOKEN, refreshToken);
        },
        async refreshIdToken() {

            if (!SessionStorageService.getItem(Auth.REFRESH_TOKEN)) {
                SessionStorageService.clear()
                router.push(Routes.LOGIN);
            }

            try {
                const response = await api.postAuthenticationToken({
                    postAuthenticationToken: {
                        grantType: "refresh-token",
                        refreshToken:  SessionStorageService.getItem(Auth.REFRESH_TOKEN),
                    },
                });

                SessionStorageService.setItem("idToken", response.idToken);

                if (response.idToken && response.refreshToken) {
                    this.setTokens(response.idToken, response.refreshToken);
                }
            } catch (error) {
                if (error instanceof ResponseError && (error.response.status < 500)) {
                    SessionStorageService.clear();
                    router.push(Routes.LOGIN);
                }
                console.error("Error refreshing token:", error);
            }
        },
        startTokenRefresh() {
            this.refreshInterval = setInterval(async () => {
                await this.refreshIdToken();
            }, 60000);
        },
        stopTokenRefresh() {
            if (this.refreshInterval) {
                clearInterval(this.refreshInterval);
                this.refreshInterval = null;
            }
        },
    },

    getters: {
        isAuthenticated: (state) => !!state.idToken,
    },
});
